'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "start", "end"];
import * as React from 'react';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { useEvent } from "../../internals/utils/useEvent.mjs";
export const CalendarGridDayEventPlaceholder = /*#__PURE__*/React.forwardRef(function CalendarGridDayEventPlaceholder(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      start,
      end
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const {
    state
  } = useEvent({
    start,
    end
  });
  return useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef],
    props: [elementProps, {
      style: {
        pointerEvents: 'none'
      }
    }]
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridDayEventPlaceholder.displayName = "CalendarGridDayEventPlaceholder";